export const isOnlyNumbers = str => {
  return /^[0-9]+$/.test(str);
};